import React from 'react';
import LazyLoad from '../../common/components/LazyLoad';
import LegacyUserResource from '../../common/resource/LegacyUserResource';
import { Icon } from '../../common/components/Utilities';

export default function ({ user, start, end }) {
  return (
    <LazyLoad
      resourceAction={LegacyUserResource.lateness}
      params={[user, start, end]}
      defaultData={0}
      render={(loading, count) => (
        loading ? (
          <Icon icon="circle-notch" variant="fad" append="fa-spin text-info" fixed />
        ) : (
          <div className={count > 0 ? 'text-danger' : ''}>
            {count}
            {' '}
            {count === 1 ? 'day' : 'days'}
          </div>
        )
      )}
    />
  );
}
